<template>
  <div>
    <b-modal
      ref="transactionModal"
      size="lg"
      header-class="header-gray"
      footer-class="footer-class"
      body-class="body-class"
      lazy
      hide-footer
      :no-enforce-focus="true"
    >
      <template #modal-title>
        Transaction Details
      </template>
      <transaction :id="transactionId"></transaction>
    </b-modal>
    <b-modal
      ref="refundVoidModal"
      size="sm"
      hide-footer
      :no-enforce-focus="true"
    >
      <template #modal-title>
        {{ refundVoidAction | title }} for {{ transaction.firstName }}
        {{ transaction.lastName }}
      </template>
      <refund-void
        lazy
        :transaction="transaction"
        :refundVoidAction="refundVoidAction"
        v-on:refundVoidModalDone="refundVoidModalDone"
      ></refund-void>
    </b-modal>

    <b-card-header class="border-0" v-if="!headless">
      <b-row>
        <b-col class="col-sm-10">
          <h3 class="mb-0">Account Ledger</h3>
        </b-col>
        <b-col style="text-align: right"> </b-col>
      </b-row>
    </b-card-header>

    <table class="table">
      <thead>
        <tr>
          <th style="width:50px">&nbsp;</th>
          <th>
            Date
          </th>
          <th v-if="!supressCustomer">
            Customer
          </th>
          <th>
            For
          </th>
          <th v-if="!supressSource">
            Source
          </th>
          <th>
            Payment Method
          </th>
          <th class="text-right">
            Amount
          </th>
          <th class="text-right" v-if="!supressBalance">
            Balance
          </th>

          <th class="text-right">
            Action
          </th>
        </tr>
      </thead>

      <template v-for="row in ledgers">
        <tr>
          <td>
            <disposition
              :reason="row.transactionResult.reason"
              :status="row.transactionResult.status"
              :refundVoidType="row.transactionResult.refundVoidType"
              :id="row.transactionResult.referenceId"
            ></disposition>
          </td>
          <td class="align-middle">
            {{ row.dateTime | moment("MM/DD/YYYY") }}<br />
            <small>{{ row.dateTime | moment("hh:mm:ss A") }}</small>
          </td>
          <td class="align-middle" v-if="!supressCustomer">
            {{ row.customerFirstName | title }}
            {{ row.customerLastName | title }}
          </td>
          <td class="align-middle">
            <a
              href="#"
              @click.prevent="$emitter.emit('show-appt', row.debitAppt.apptId)"
              >{{ row.friendlyDescription }}</a
            >
          </td>
          <td class="align-middle">
            {{ row.transactionResult.source | title }}
          </td>

          <td class="align-middle">
            <card-svg :cardType="row.transactionResult.cardType" />
            {{ row.transactionResult.cardDescription }}
          </td>
          <td class="text-right align-middle">
            <i
              class="fa-solid fa-circle-half-stroke"
              v-if="
                row.transactionResult.refundVoidType &&
                  row.transactionResult.refundVoidAmount != row.amount
              "
              v-b-tooltip.hover
              title="Partial Refund"
            ></i>

            {{ (row.amount / 100) | currency }}
          </td>
          <td class="text-right align-middle" v-if="!supressBalance">
            {{ (row.balance / 100) | currency }}
          </td>
          <td style="text-align:right">
            <b-dropdown
              dropleft
              variant="link"
              toggle-class="text-decoration-none"
              class="p-0 m-0"
              no-caret
              size="lg"
              id="dropdown-1"
              text="Action"
              @show="setSettledAction(row)"
            >
              <template #button-content>
                <i class="fas fa-ellipsis-h"></i>
              </template>

              <template
                v-if="!row.transactionResult.refundVoidType && !row.noAction"
              >
                <b-dropdown-item
                  v-if="row.isSettled === true"
                  @click.prevent="showRefundVoid(row, 'REFUND')"
                >
                  <i class="icomoon icon-status-refunded text-warning"></i
                  >Refund</b-dropdown-item
                >
                <b-dropdown-item
                  v-if="row.isSettled === false"
                  @click.prevent="showRefundVoid(row, 'VOID')"
                >
                  <i class="icomoon icon-status-voided text-muted"></i
                  >Void</b-dropdown-item
                >
              </template>
              <b-dropdown-item @click.prevent="showTransaction(row)">
                <i class="icomoon icon-details-system"></i>Transaction
                Details</b-dropdown-item
              >
            </b-dropdown>
          </td>
        </tr>
      </template>
    </table>

    <b-pagination
      align="center"
      class="mt-3"
      v-if="showPagination"
      v-model="currentPage"
      :total-rows="rows"
      :per-page="perPage"
      @change="pageChange"
    ></b-pagination>
  </div>
</template>
<script>
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
} from "element-ui";

import swal from "sweetalert2";
import RefundVoid from "@/views/Components/Transactions/RefundVoid";
import Transaction from "@/views/Components/Transactions/Transaction";

export default {
  name: "acct-search-results",

  props: {
    supressCustomer: false,
    supressBalance: false,
    supressSource: false,
    headless: false,
    supressOptions: false,
    query: {
      customerId: null,
      apptId: null,
      startDate: null,
      endDate: null,
    },
  },
  components: {
    "refund-void": RefundVoid,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    transaction: Transaction,
  },
  watch: {
    query: {
      immediate: true,
      async handler(newVal) {
        this.bind(1);
      },
      deep: true,
    },
  },
  mounted() {
    this.$emitter.once("bind-transactions", (e) => {
      this.bind(this.currentPage);
    });
  },
  methods: {
    refundVoidModalDone() {
      this.$refs.refundVoidModal.hide();
      this.bind(this.currentPage);
    },
    showTransaction(transaction) {
      this.transactionId = transaction.id;
      this.transaction = transaction;

      this.$refs.transactionModal.show();
    },
    getVoidRefundHover(row) {
      var self = this;
      return (
        self.$root.$options.filters.title(row.refundVoidType) +
        " " +
        self.$root.$options.filters.currency(row.refundVoidAmount / 100) +
        ".  Transaction ID : " +
        row.refundVoidReferenceId.split("-")[0]
      );
    },
    showRefundVoid(transaction, action) {
      console.log(transaction);
      var self = this;
      self.refundVoidAction = action;
      self.transaction = transaction;
      this.$refs.refundVoidModal.show();
    },

    getHeader(a) {
      return a;
    },
    sort(a) {
      var self = this;
      self.sortOption = a.prop + ":" + a.order;
      self.bind(1);
    },
    async bind(page) {
      this.currentPage = page;

      var form = this.query;

      form.currentPage = page;
      form.sortOption = self.sortOption;

      var r = await this.$client.post("/api/customerAcct/getAcctLedger", form);

      r.data.value.ledgers.forEach((e) => {
        e.isSettled = null; // reactivity hack
      });

      this.ledgers = r.data.value.ledgers;

      this.rows = this.ledgers[0].rows;

      this.showPagination = this.rows > 10;

      this.$emit("length", ledgers.length);
    },
    setSettledAction(transaction) {
      if (transaction.status == "APPROVED" && transaction.referenceId) {
        transaction.isSettled = null;
        this.isSettled(transaction);
      } else {
        transaction.noAction = true;
      }
    },
    isSettled(transaction) {
      var self = this;

      self.$client
        .get("/api/acct/getTransaction?id=" + transaction.referenceId)
        .then((result) => {
          let t = self.transactions.find((a) => {
            return a.referenceId == transaction.referenceId;
          });

          t.isSettled = result.data.value.isSettled;
        });
    },
    pageChange(page) {
      this.bind(page);
    },
    newSort() {
      var self = this;

      self.bind(page);
    },
  },
  data() {
    return {
      refundVoidAction: null,
      selectedTransaction: null,
      showPagination: false,
      referenceId: null,
      sortOption: "Date:descending",
      rows: null,
      currentPage: 1,
      perPage: 10,
      transaction: null,
      transactionId: null,
      ledgers: [],
    };
  },
};
</script>
<style>
.trans-amount {
  display: inline-block;
}
.fa-circle-half-stroke {
  font-size: 0.8em;
  position: relative;
  top: -1px;
  padding-right: 5px;
  color: #fb6340;
}
</style>
